var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 113,
    viewBox: "0 0 112 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9188 0.000919274C50.3351 0.0222173 45.9578 0.413137 42.1063 1.09467C30.7601 3.09917 28.7 7.29477 28.7 15.0322V25.2509H55.5125V28.6572H28.7H18.6375C10.8451 28.6572 4.02178 33.3409 1.88754 42.2509C-0.574285 52.4639 -0.68348 58.8369 1.88754 69.5009C3.79346 77.4388 8.34508 83.0947 16.1375 83.0947H25.3563V70.8447C25.3563 61.9948 33.0134 54.1884 42.1063 54.1884H68.8875C76.3425 54.1884 82.2938 48.0503 82.2938 40.5634V15.0322C82.2938 7.76583 76.1638 2.30739 68.8875 1.09467C64.2815 0.327944 59.5024 -0.020379 54.9188 0.000919274ZM40.4188 8.21967C43.1883 8.21967 45.45 10.5183 45.45 13.3447C45.45 16.161 43.1883 18.4384 40.4188 18.4384C37.6393 18.4384 35.3875 16.161 35.3875 13.3447C35.3875 10.5183 37.6393 8.21967 40.4188 8.21967Z",
    fill: "url(#paint0_linear_219_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6377 28.6572V40.5635C85.6377 49.7942 77.8118 57.5635 68.8877 57.5635H42.1064C34.7706 57.5635 28.7002 63.842 28.7002 71.1885V96.7197C28.7002 103.986 35.0188 108.26 42.1064 110.345C50.5938 112.84 58.7327 113.291 68.8877 110.345C75.6379 108.39 82.2939 104.457 82.2939 96.7197V86.501H55.5127V83.0947H82.2939H95.7002C103.493 83.0947 106.396 77.6593 109.106 69.501C111.906 61.1021 111.787 53.0252 109.106 42.251C107.181 34.4935 103.503 28.6572 95.7002 28.6572H85.6377ZM70.5752 93.3135C73.3547 93.3135 75.6064 95.5909 75.6064 98.4072C75.6064 101.234 73.3547 103.532 70.5752 103.532C67.8056 103.532 65.5439 101.234 65.5439 98.4072C65.5439 95.5909 67.8056 93.3135 70.5752 93.3135Z",
    fill: "url(#paint1_linear_219_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_6",
    x1: -3.34028e-7,
    y1: -2.90161e-7,
    x2: 61.8267,
    y2: 52.6849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_6",
    x1: 69.9309,
    y1: 97.5481,
    x2: 47.7498,
    y2: 66.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.a3e6082d17fc57009e7af0b1dd7490c9.svg";
export { ForwardRef as ReactComponent };